export const CHANNELS = ["email", "whatsapp_sms", "push", "llamadas"];

// Do not infer a country code. Keep an explicitly supplied + and digits.
export function normalizeConsentPhone(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  if (!/^\+?[\d () .-]+$/.test(raw) || digits.length < 7 || digits.length > 15)
    return null;
  return `${raw.startsWith("+") ? "+" : ""}${digits}`;
}

// Server metadata refers to stable field names, never translated labels.
export function getCommunicationConfig(definition, fields) {
  const config = definition?.communicationConsent;
  if (!config) return null;
  const names = [
    config.legalField,
    config.marketingField,
    ...CHANNELS.map(key => config.channels?.[key]),
    config.phoneField,
  ];
  const byName = new Map((fields || []).map(field => [field.name, field]));
  if (
    config.schemaVersion !== 1 ||
    names.some(name => !name || !byName.has(name)) ||
    new Set(names).size !== names.length ||
    names.slice(0, -1).some(name => byName.get(name).type !== "checkbox") ||
    !byName.get(config.legalField).required ||
    names.slice(1).some(name => byName.get(name).required) ||
    byName.get(config.phoneField).type !== "tel"
  ) {
    throw new Error("Invalid communication consent configuration");
  }
  return config;
}

export function updateCommunicationValues(values, name, value, config) {
  const next = { ...values, [name]: value };
  if (!config) return next;
  const channels = CHANNELS.map(key => config.channels[key]);
  if (name === config.marketingField)
    channels.forEach(field => { next[field] = value === true; });
  if (name === config.marketingField || channels.includes(name)) {
    channels.forEach(field => { next[field] = next[field] === true; });
    next[config.marketingField] = channels.some(field => next[field]);
  }
  return next;
}

export function captureCommunication(values, config) {
  const authorizedChannels = Object.fromEntries(
    CHANNELS.map(key => [key, values[config.channels[key]] === true]),
  );
  return {
    schemaVersion: 1,
    acceptsMarketing: Object.values(authorizedChannels).some(Boolean),
    authorizedChannels,
  };
}

export function buildTermsEvidence(draft, user) {
  const root = document.createElement("div");
  root.innerHTML = draft.text || "";
  const customer = {};
  if (typeof user?.name === "string" && user.name.trim())
    customer.name = user.name.trim();
  const phone = normalizeConsentPhone(draft.customerPhone || user?.phone);
  if (phone) customer.phone = phone;
  return {
    customer,
    legalEvidence: {
      ...(draft.legalDocument || {}),
      html: draft.text || "",
      text: root.textContent.replace(/\s+/g, " ").trim(),
    },
    ...(draft.communicationConsent
      ? { communicationConsent: { ...draft.communicationConsent, capturedAt: draft.acceptedAt } }
      : {}),
  };
}
